import axios from "axios";
import ConfigurationManager from "../settings/ConfigurationManager";

export async function genericPost({
    url_endpoint,
    body,
    message_info,
    message_error,
}) {
    var url = `${ConfigurationManager.API_URL}${url_endpoint}`;

    return await axios
        .post(url, body, { headers: ConfigurationManager.JSON_HEADER })
        .catch((e) => {
            console.error(e);
            return e;
        });
}

export async function genericPostUpload({
    url_endpoint,
    data,
    message_info,
    message_error,
}) {
    return await axios
        .post(`${ConfigurationManager.API_URL}${url_endpoint}`, { data: data })
        .catch((e) => {
            console.error(e);
            return e;
        });
}

export async function genericGet({
    url_endpoint,
    message_info,
    message_error,
}) {
    return await axios
        .get(`${ConfigurationManager.API_URL}${url_endpoint}`)
        .catch((e) => {
            console.error(e);
            return e;
        });
}

export async function genericDelete({
    url_endpoint,
    message_info,
    message_error,
}) {
    return await axios
        .delete(`${ConfigurationManager.API_URL}${url_endpoint}`)
        .catch((e) => {
            console.error(e);
            return e;
        });
}

export async function genericPut({
    url_endpoint,
    body,
    message_info,
    message_error,
}) {
    return await axios
        .put(`${ConfigurationManager.API_URL}${url_endpoint}`, body, {
            headers: ConfigurationManager.JSON_HEADER,
        })
        .catch((e) => {
            console.error(e);
            return e;
        });
}